Vue.component("guide-salepage-component", require("./Index.vue").default);
